import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconFuelType = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M21 14C21 16.21 19.21 18 17 18C14.79 18 13 16.21 13 14C13 11.79 17 6 17 6C17 6 21 11.79 21 14Z" }),
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M11 10H7V3L3 14H7V21L11 10Z" }))));
};
